import { render, staticRenderFns } from "./perfectInfo2.vue?vue&type=template&id=70063cd6&scoped=true"
import script from "./perfectInfo2.vue?vue&type=script&lang=js"
export * from "./perfectInfo2.vue?vue&type=script&lang=js"
import style0 from "./perfectInfo2.vue?vue&type=style&index=0&id=70063cd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70063cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70063cd6')) {
      api.createRecord('70063cd6', component.options)
    } else {
      api.reload('70063cd6', component.options)
    }
    module.hot.accept("./perfectInfo2.vue?vue&type=template&id=70063cd6&scoped=true", function () {
      api.rerender('70063cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/perfectInfo2.vue"
export default component.exports